module.exports = __webpack_public_path__ + "assets/img/Healthy-Hip-Hop-Logo.3bd0b169.png";